import { RecommendationItem } from "./calcBusterTypes";
import { groupBy } from "shared/util/common/util";

export const getSavingsArray = (recommendations: RecommendationItem[]) => {
  if (!recommendations || recommendations.length == 0) return [];

  const recommendationsGroupedByService = groupBy(recommendations, "service");
  return sumSavingsByService(recommendationsGroupedByService);
};

function sumSavingsByService(
  recommendationsGroupedByService: Record<string, RecommendationItem[]>
) {
  const serviceTypes = Object.keys(recommendationsGroupedByService);
  return serviceTypes.map((serviceType) => {
    const savingsByService = recommendationsGroupedByService[serviceType].map(
      (item: RecommendationItem) => item.savings
    );
    return {
      name: serviceType,
      value: savingsByService.reduce(
        (prev: number, curr: number) => prev + curr
      ),
    };
  });
}

export const USDollar = new Intl.NumberFormat("en-US", {
  style: "currency",
  currency: "USD",
});
